import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Encashment History       ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Encash Now ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Enter OTP")
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_8 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "Ref. #"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Date"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "Fullname"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Destination"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Account #"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Gross"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Net"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-150px rounded-end" }, "Currency"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-150px rounded-end" }, "Wallet")
  ])
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_encashment_process = _resolveComponent("encashment-process")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        (!_ctx.isOverriden)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-primary er fs-6 px-8 py-2",
              "data-bs-toggle": "modal",
              "data-bs-target": `#kt_modal_encashment_process`,
              onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.refreshEncashmentProcessModal();})
            }, [
              (_ctx.hasPendingChinatrustOTP == false && _ctx.hasPendingEncashmentOTP == false)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_3
                  ], 64))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_4
                  ], 64))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_encashment_process, {
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.encProcKey++)),
        key: _ctx.encProcKey
      }),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("table", _hoisted_7, [
            _hoisted_8,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", null, "   " + _toDisplayString(item.id), 1),
                  _createVNode("td", null, _toDisplayString(item.txndte), 1),
                  _createVNode("td", null, _toDisplayString(item.fullname), 1),
                  (item.destination == 'Bank' || item.destination == 'Cash' || item.destination == 'IBayad' || item.destination == 'Chinatrust')
                    ? (_openBlock(), _createBlock("td", _hoisted_9, _toDisplayString(item.destination), 1))
                    : (item.destination == 'W')
                      ? (_openBlock(), _createBlock("td", _hoisted_10, "EC Wallet Top-Up"))
                      : (_openBlock(), _createBlock("td", _hoisted_11, [
                          (item.chequereleasebranch != null && item.chequereleasebranch != '')
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(item.destination) + " / " + _toDisplayString(item.chequereleasebranch), 1)
                              ], 64))
                            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(item.destination), 1)
                              ], 64))
                        ])),
                  _createVNode("td", null, _toDisplayString(item.accountno), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(item.gross.toFixed(2))), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(item.net.toFixed(2))), 1),
                  _createVNode("td", null, _toDisplayString(item.ccy3), 1),
                  _createVNode("td", null, _toDisplayString(item.encashFrom == 'DRC' ? 'Personal Direct Sales Commission' : ''), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}